import dva from 'dva'
import './components/common/less/common.less'
import 'animate.css'

// 1. Initialize
const app = dva()

// 2. Plugins
// app.use({});

// 3. Model
app.model(require('./models/layout/MainLayout'))
app.model(require('./models/layout/SiderParent'))
app.model(require('./models/homePage/Index'))

// 4. Router
app.router(require('./router'))

// 5. Start
app.start('#root')



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/